import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from '@itds/elements/index.js';
import { NOTIFICATION_TRIGGERS } from '@itds/Constants';

import EditNotificationTrigger from './EditNotificationTrigger';

import Api from '@brokerage/utils/Api';

const NotificationTriggers = ({ member }) => {
  const [notification_triggers, setNotificationTriggers] = useState([]);
  const [trigger, setTrigger] = useState({});
  const [products, setProducts] = useState([]);

  useEffect(() => {
    loadNotificationTriggers();

    Api.loadIxnProducts({ member_id: member.id }).then(({ data }) => {
      setProducts(data);
    });
  }, []);

  const loadNotificationTriggers = () => {
    Api.loadNotificationTriggers(member.id).then(({ data }) => {
      setNotificationTriggers(data);
    });
  };

  const deleteTrigger = (trigger, e) => {
    e.stopPropagation();

    Api.deleteNotificationTrigger(trigger.id).then(() => {
      loadNotificationTriggers(member.id);
    });
  };

  const handleSave = () => {
    loadNotificationTriggers();
    setTrigger({});
  };

  return (
    <div>
      <EditNotificationTrigger
        member={member}
        onClose={setTrigger.bind(null, {})}
        onSave={handleSave}
        products={products}
        show={!!trigger.id || !!trigger._new}
        trigger={trigger}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          inline={true}
          onClick={setTrigger.bind(null, {
            _new: true,
            name: '',
            product_id: '',
            notification_type: '',
            trigger: '',
            emails: [],
            agency_id: ''
          })}
        >
          New Trigger
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'agency',
            label: 'Agency',
            render: trigger => {
              const agency = member.agencies.find(a => a.id === trigger.agency_id);

              return agency ? agency.name : 'Unknown';
            }
          },
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'trigger',
            label: 'Trigger',
            render: trigger => NOTIFICATION_TRIGGERS.find(t => t.value === trigger.trigger).label
          },
          {
            id: 'product_type',
            label: 'Product',
            render: trigger => {
              return trigger.product_id
                ? `${trigger.product_type} (id: ${trigger.product_id})`
                : 'All Products';
            }
          },
          {
            id: 'notification_type',
            label: 'Delivery Method',
            render: trigger => (trigger.notification_type === 'email' ? 'Email' : 'Web Call')
          },
          {
            id: 'actions',
            label: '',
            render: trigger => (
              <Button
                color='RED'
                inline={true}
                onClick={deleteTrigger.bind(null, trigger)}
                small={true}
              >
                Delete
              </Button>
            ),
            styles: { textAlign: 'right' }
          }
        ]}
        data={notification_triggers}
        onRowClick={setTrigger}
        placeholder='No Notification Triggers Found'
      />
    </div>
  );
};

NotificationTriggers.propTypes = {
  member: PropTypes.object
};

export default NotificationTriggers;
